/**
 * Created by sairam on 14/04/17.
 */
import { createReducer } from 'reducers';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    LOGIN_REQUESTED,
    LOGIN_SUCCESSFUL,
    LOGIN_FAILED,
} from './LoginActionTypes';

export const loginInitialState = Map({
  session: Map(),
  user: Map(),
  error: Map(),
  isLoading: false,
  attrbutes: Map(),
  errorMessage: '',
});

const handlers = {
  [LOGIN_REQUESTED](state) {
    return state.merge({
      isLoginRequested: true,
      isLoading: true,
    });
  },
  [LOGIN_FAILED](state, action) {
    return state.merge({
      isLoginRequested: false,
      isLoading: false,
      error: action.error,
      errorMessage: action.erro,
    });
  },
  [LOGIN_SUCCESSFUL](state, action) {
    return state.merge({
      session: action.session,
      attributes: action.attributes,
      isLoading: false,
    });
  },
};

export const login = createReducer(loginInitialState, handlers);


// LOGIN SELECTOR
// Selectors
const getError = state => state.register.get('error');
const getSession = state => state.register.get('session');
const getUser = state => state.register.get('user');
const getIsLoading = state => state.register.get('isLoading');
const getAttributes = state => state.register.get('attributes');
const getErrorMessage = state => state.register.get('errorMessage');

export const loginSelector = createStructuredSelector({
  error: getError,
  session: getSession,
  user: getUser,
  isLoading: getIsLoading,
  attributes: getAttributes,
  errorMessage: getErrorMessage,
});




// WEBPACK FOOTER //
// ./src/containers/Login/Login.redux.js